(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    if (window.__adelineCartQtyInit) return;
    window.__adelineCartQtyInit = true;

    let cartData = null;

    async function fetchCartData(force = false) {
      if (cartData && !force) {
        return cartData;
      }

      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) {
        throw new Error('Unable to fetch cart data.');
      }

      cartData = await response.json();
      return cartData;
    }

    async function updateCartItems(updateData) {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates: updateData }),
      });

      if (!response.ok) {
        throw new Error('Unable to update cart items.');
      }

      cartData = await response.json();
      return cartData;
    }

    async function changeLineItemProperties(item, properties) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties,
        }),
      });

      if (!response.ok) {
        throw new Error('Unable to clean bundle properties.');
      }

      cartData = await response.json();
      return cartData;
    }

    function getLineItemKeyFromUrl(url) {
      if (!url) return null;

      try {
        const parsedUrl = new URL(url, window.location.origin);
        return parsedUrl.searchParams.get('id');
      } catch (error) {
        const match = String(url).match(/[?&]id=([^&]+)/);
        return match ? decodeURIComponent(match[1]) : null;
      }
    }

    function buildBundleGroups(cart) {
      const bundleGroups = {};

      (cart?.items || []).forEach((item) => {
        const bundleId = item.properties?._bundle_id;
        const bundleRole = item.properties?._bundle_role;

        if (!bundleId) return;

        if (!bundleGroups[bundleId]) {
          bundleGroups[bundleId] = { main: null, children: [] };
        }

        if (bundleRole === 'main') {
          bundleGroups[bundleId].main = item;
        } else if (bundleRole) {
          bundleGroups[bundleId].children.push(item);
        }
      });

      return bundleGroups;
    }

    function normalisePropertyKey(propertyName) {
      return String(propertyName || '')
        .replace(/^_+/, '')
        .toLowerCase()
        .replace(/[\s_]+/g, '-');
    }

    function getAddonRoleFromProperty(propertyName) {
      const normalisedName = normalisePropertyKey(propertyName);

      if (normalisedName.includes('storage-add-on') || normalisedName.includes('storage-addon')) {
        return 'storage';
      }

      if (normalisedName.includes('mattress-add-on') || normalisedName.includes('mattress-addon')) {
        return 'mattress';
      }

      if (normalisedName.includes('service-add-on') || normalisedName.includes('service-addon')) {
        return 'service';
      }

      return null;
    }

    function getChildDisplayTitle(child) {
      const variantTitle = child?.variant_title || '';
      if (variantTitle && variantTitle !== 'Default Title') {
        return variantTitle;
      }

      const variantOptions = Array.isArray(child?.variant_options)
        ? child.variant_options.filter((option) => option && option !== 'Default Title').join(' / ')
        : '';

      if (variantOptions) {
        return variantOptions;
      }

      return child?.product_title || child?.title || '';
    }

    function isAddonVariantIdProperty(propertyName) {
      const normalisedName = normalisePropertyKey(propertyName);
      return normalisedName.includes('variant-id') || normalisedName.endsWith('-id');
    }

    function cleanPropertiesForActiveChildren(properties, children) {
      const childrenByRole = (children || []).reduce((groups, child) => {
        const role = child.properties?._bundle_role;
        if (!role) return groups;

        if (!groups[role]) {
          groups[role] = [];
        }

        groups[role].push(child);
        return groups;
      }, {});
      const cleanedProperties = {};

      Object.entries(properties || {}).forEach(([propertyName, propertyValue]) => {
        if (propertyValue === null || propertyValue === undefined || propertyValue === '') {
          return;
        }

        const addonRole = getAddonRoleFromProperty(propertyName);
        if (addonRole) {
          const activeChildren = childrenByRole[addonRole] || [];

          if (!activeChildren.length) {
            return;
          }

          if (!isAddonVariantIdProperty(propertyName)) {
            const activeAddonNames = activeChildren
              .map(getChildDisplayTitle)
              .filter(Boolean)
              .join(', ');

            cleanedProperties[propertyName] = activeAddonNames || propertyValue;
            return;
          }
        }

        cleanedProperties[propertyName] = propertyValue;
      });

      return cleanedProperties;
    }

    function propertiesHaveChanged(currentProperties, cleanedProperties) {
      const currentEntries = Object.entries(currentProperties || {}).filter(([, value]) => {
        return value !== null && value !== undefined && value !== '';
      });
      const cleanedEntries = Object.entries(cleanedProperties || {});

      if (currentEntries.length !== cleanedEntries.length) {
        return true;
      }

      return currentEntries.some(([key, value]) => String(cleanedProperties[key] ?? '') !== String(value ?? ''));
    }

    async function cleanParentPropertiesForBundle(bundleId) {
      if (!bundleId) return false;

      const cart = await fetchCartData(true);
      const bundleGroups = buildBundleGroups(cart);
      const group = bundleGroups[bundleId];

      if (!group?.main) {
        return false;
      }

      const cleanedProperties = cleanPropertiesForActiveChildren(group.main.properties, group.children);
      if (!propertiesHaveChanged(group.main.properties, cleanedProperties)) {
        return false;
      }

      await changeLineItemProperties(group.main, cleanedProperties);
      return true;
    }

    async function cleanupBundleCart() {
      try {
        let cart = await fetchCartData(true);
        let bundleGroups = buildBundleGroups(cart);
        const orphanedKeys = [];

        Object.values(bundleGroups).forEach((group) => {
          if (!group.main && group.children.length > 0) {
            group.children.forEach((child) => {
              orphanedKeys.push(child.key);
            });
          }
        });

        let cartWasChanged = false;

        if (orphanedKeys.length > 0) {
          const updateData = {};
          orphanedKeys.forEach((key) => {
            updateData[key] = 0;
          });

          await updateCartItems(updateData);
          cartWasChanged = true;
          cart = await fetchCartData(true);
          bundleGroups = buildBundleGroups(cart);
        }

        for (const bundleId of Object.keys(bundleGroups)) {
          const latestGroups = buildBundleGroups(cartData);
          const group = latestGroups[bundleId];

          if (!group?.main) {
            continue;
          }

          const cleanedProperties = cleanPropertiesForActiveChildren(group.main.properties, group.children);
          if (!propertiesHaveChanged(group.main.properties, cleanedProperties)) {
            continue;
          }

          await changeLineItemProperties(group.main, cleanedProperties);
          cartWasChanged = true;
          cart = await fetchCartData(true);
        }

        if (cartWasChanged) {
          window.location.reload();
        }
      } catch (error) {
        console.error('Error cleaning up bundle cart:', error);
      }
    }

    function getBundleChildrenKeys(bundleId) {
      if (!cartData || !bundleId) return [];

      return cartData.items
        .filter((item) => item.properties?._bundle_id === bundleId && item.properties?._bundle_role !== 'main')
        .map((item) => item.key);
    }

    document.addEventListener('click', async (event) => {
      const removeLink = event.target.closest('.cart-item-remove');
      if (!removeLink) return;

      const cartItem = removeLink.closest('.cart-item');
      if (!cartItem) return;

      const bundleInput = cartItem.querySelector('[data-bundle-parent-input]');
      if (!bundleInput) return;

      const bundleId = bundleInput.getAttribute('data-bundle-id');
      if (!bundleId) return;

      event.preventDefault();

      const href = removeLink.getAttribute('href');

      try {
        const cart = await fetchCartData(true);
        const bundleGroups = buildBundleGroups(cart);
        const bundleGroup = bundleGroups[bundleId];
        const mainItemKey = bundleGroup?.main?.key || getLineItemKeyFromUrl(href);
        const childrenKeys = getBundleChildrenKeys(bundleId);
        const updateData = {};

        if (mainItemKey) {
          updateData[mainItemKey] = 0;
        }

        childrenKeys.forEach((key) => {
          updateData[key] = 0;
        });

        if (!Object.keys(updateData).length) {
          window.location.href = href;
          return;
        }

        await updateCartItems(updateData);
        window.location.reload();
      } catch (error) {
        console.error('Error removing bundle:', error);
        window.location.href = href;
      }
    });

    document.addEventListener('click', async (event) => {
      const bundleRemoveLink = event.target.closest('[data-bundle-child-remove], .cart-bundle-remove');
      if (!bundleRemoveLink) return;

      event.preventDefault();

      const href = bundleRemoveLink.getAttribute('href');
      const linkKey = bundleRemoveLink.getAttribute('data-bundle-key') || getLineItemKeyFromUrl(href);

      try {
        const cart = await fetchCartData(true);
        const childItem = (cart.items || []).find((item) => item.key === linkKey);
        const childKey = childItem?.key || linkKey;
        const bundleId = childItem?.properties?._bundle_id || bundleRemoveLink.getAttribute('data-bundle-id');

        if (!childKey) {
          window.location.href = href;
          return;
        }

        await updateCartItems({ [childKey]: 0 });
        await cleanParentPropertiesForBundle(bundleId);
        window.location.reload();
      } catch (error) {
        console.error('Error removing add-on from bundle:', error);
        window.location.href = href;
      }
    });

    cleanupBundleCart();

    function syncBundleChildQuantities(input) {
      if (!input || !input.hasAttribute('data-bundle-parent-input')) {
        return;
      }

      const bundleId = input.getAttribute('data-bundle-id');
      if (!bundleId) {
        return;
      }

      const nextValue = String(Math.max(0, Number.parseInt(input.value, 10) || 0));
      document.querySelectorAll(`[data-bundle-child-input][data-bundle-id="${bundleId}"]`).forEach((childInput) => {
        childInput.value = nextValue;
      });
    }

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-qty-btn]');
      if (!button) return;

      const inputId = button.getAttribute('data-target');
      const input = document.getElementById(inputId);
      if (!input) return;

      const currentValue = Number.parseInt(input.value, 10) || 0;
      const minValue = Number.parseInt(input.min, 10) || 0;
      const maxValue = input.max ? Number.parseInt(input.max, 10) : Infinity;
      const delta = button.dataset.qtyBtn === 'increase' ? 1 : -1;
      const nextValue = Math.min(maxValue, Math.max(minValue, currentValue + delta));

      input.value = String(nextValue);
      syncBundleChildQuantities(input);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.addEventListener('change', (event) => {
      const input = event.target.closest('[data-bundle-parent-input]');
      if (!input) return;

      syncBundleChildQuantities(input);
    });

    document.querySelectorAll('[data-bundle-parent-input]').forEach((input) => {
      syncBundleChildQuantities(input);
    });
  })();

  (() => {
    if (window.__adelineCartPromoInit) return;
    window.__adelineCartPromoInit = true;

    const promoEl = document.querySelector('[data-active-promo]');
    if (!promoEl) return;

    let promo;
    try {
      promo = JSON.parse(promoEl.textContent || '{}');
    } catch (e) {
      return;
    }
    if (!promo || !promo.code) return;

    const promoCode = String(promo.code).trim();
    if (!promoCode) return;

    const banner = document.querySelector('[data-cart-promo-banner]');
    const isCartPage = !!document.querySelector('[data-cart-page]');

    async function maybeAutoApply() {
      if (!isCartPage) return;
      if (banner && banner.getAttribute('data-applied-code')) return;

      const storageKey = 'adelinePromoAutoApplied:' + promoCode.toUpperCase();
      let alreadyTried = false;
      try { alreadyTried = sessionStorage.getItem(storageKey) === '1'; } catch (e) {}
      if (alreadyTried) return;

      let cart;
      try {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!res.ok) return;
        cart = await res.json();
      } catch (e) { return; }

      if (!cart || (cart.item_count || 0) === 0) return;

      const existingCodes = (cart.discount_codes || []).filter((d) => d && d.applicable && d.code);
      if (existingCodes.length > 0) return;

      try { sessionStorage.setItem(storageKey, '1'); } catch (e) {}
      window.location.replace('/discount/' + encodeURIComponent(promoCode) + '?redirect=/cart');
    }

    function parseCountdownDate(value) {
      if (!value) return null;
      const raw = String(value).trim();
      if (!raw) return null;
      const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
      const parsed = new Date(normalized);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    function computeRemainingMs() {
      const now = new Date();
      if (promo.byDate && promo.endDate) {
        const target = parseCountdownDate(promo.endDate);
        if (!target) return 0;
        return target - now;
      }
      const resetHour = Number.isFinite(promo.resetHour) ? promo.resetHour : 24;
      const nextReset = new Date();
      nextReset.setHours(resetHour, 0, 0, 0);
      if (now > nextReset) nextReset.setDate(nextReset.getDate() + 1);
      return nextReset - now;
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    function startBannerCountdown() {
      function tick() {
        const out = document.querySelector('[data-cart-promo-countdown]');
        if (!out) return;
        const remaining = Math.max(0, computeRemainingMs());
        const totalSec = Math.floor(remaining / 1000);
        const days = Math.floor(totalSec / 86400);
        const hours = Math.floor((totalSec % 86400) / 3600);
        const minutes = Math.floor((totalSec % 3600) / 60);
        const seconds = totalSec % 60;
        out.textContent = days > 0
          ? days + 'd ' + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds)
          : pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
      }

      tick();
      setInterval(tick, 1000);
    }

    maybeAutoApply();
    startBannerCountdown();
  })();

  (() => {
    if (window.__adelineCartUpsellsInit) return;
    window.__adelineCartUpsellsInit = true;

    const SECTION_ID = '{{ section.id }}';

    function generateBundleId() {
      return 'bundle-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
    }

    async function fetchJson(url, options) {
      const res = await fetch(url, Object.assign({ credentials: 'same-origin' }, options || {}));
      if (!res.ok) {
        const text = await res.text().catch(() => '');
        const error = new Error('Request failed: ' + res.status + ' ' + text);
        error.status = res.status;
        throw error;
      }
      return res.json();
    }

    async function refreshCartSection() {
      try {
        const res = await fetch('/?sections=' + encodeURIComponent(SECTION_ID), { credentials: 'same-origin' });
        if (!res.ok) throw new Error('Section fetch failed');
        const data = await res.json();
        const html = data[SECTION_ID];
        if (!html) throw new Error('No section html');

        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        const newSection = wrapper.querySelector('[data-cart-page]');
        const currentSection = document.querySelector('[data-cart-page]');
        if (!newSection || !currentSection) throw new Error('Cart container missing');

        currentSection.innerHTML = newSection.innerHTML;
        wireCartUpsells();
      } catch (e) {
        window.location.reload();
      }
    }

    async function ensureParentHasBundleId(upsellRoot) {
      const existing = upsellRoot.getAttribute('data-cart-item-bundle-id');
      if (existing) return existing;

      const parentKey = upsellRoot.getAttribute('data-cart-item-key');
      if (!parentKey) throw new Error('Missing parent key');

      const cart = await fetchJson('/cart.js');
      const parentItem = (cart.items || []).find((it) => it.key === parentKey);
      if (!parentItem) throw new Error('Parent item not found');

      const existingProps = Object.assign({}, parentItem.properties || {});
      let bundleId = existingProps._bundle_id;

      if (!bundleId) {
        bundleId = generateBundleId();
        existingProps._bundle_id = bundleId;
        existingProps._bundle_role = 'main';

        await fetchJson('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parentKey, quantity: parentItem.quantity, properties: existingProps }),
        });
      }

      upsellRoot.setAttribute('data-cart-item-bundle-id', bundleId);
      return bundleId;
    }

    async function addService(button) {
      if (button.getAttribute('aria-busy') === 'true' || button.getAttribute('data-cart-added') === 'true') return;

      const serviceBundle = button.closest('[data-service-bundle]');
      const upsellRoot = button.closest('[data-cart-upsells]');
      if (!serviceBundle || !upsellRoot) return;

      const variantIdRaw = button.getAttribute('data-service-variant-id') || '';
      const variantId = Number.parseInt(variantIdRaw, 10);
      if (!variantId || !Number.isFinite(variantId)) {
        console.warn('[cart-upsell] Skipping service with invalid variant id:', variantIdRaw);
        button.disabled = true;
        return;
      }

      const title = button.getAttribute('data-service-title') || '';
      const groupLabel = button.getAttribute('data-service-group-label') || 'Services';

      const labelEl = button.querySelector('[data-service-button-label]');
      const originalLabel = labelEl ? labelEl.textContent : button.textContent;
      button.setAttribute('aria-busy', 'true');
      if (labelEl) labelEl.textContent = 'Adding...';

      try {
        const bundleId = await ensureParentHasBundleId(upsellRoot);

        const properties = {
          _bundle_id: bundleId,
          _bundle_role: 'service',
          _service_group: groupLabel,
          _Service_Title: title,
        };
        properties[groupLabel] = title;

        await fetchJson('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] }),
        });

        button.setAttribute('data-cart-added', 'true');
        if (labelEl) labelEl.textContent = 'Added';

        await refreshCartSection();
      } catch (e) {
        console.error('[cart-upsell] Failed to add service:', e);
        if (labelEl) labelEl.textContent = originalLabel;
        button.setAttribute('aria-busy', 'false');
        try {
          const toast = document.createElement('div');
          toast.textContent = 'Could not add service. Please try again.';
          toast.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:#b12f2f;color:#fff;padding:10px 16px;border-radius:8px;font-size:13px;z-index:9999;box-shadow:0 4px 12px rgba(0,0,0,.2);';
          document.body.appendChild(toast);
          setTimeout(() => toast.remove(), 3000);
        } catch (_) {}
      }
    }

    function wireCartUpsells() {
      document.querySelectorAll('[data-cart-upsell-toggle]').forEach((toggle) => {
        if (toggle.__wired) return;
        toggle.__wired = true;
        toggle.addEventListener('click', () => {
          const card = toggle.closest('[data-cart-upsell-service]');
          if (!card) return;
          const body = card.querySelector('[data-cart-upsell-body]');
          if (!body) return;
          const open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (open) {
            body.setAttribute('hidden', '');
          } else {
            body.removeAttribute('hidden');
          }
        });
      });

      document.querySelectorAll('[data-cart-upsells] [data-service-option]').forEach((btn) => {
        if (btn.__wired) return;
        btn.__wired = true;
        const variantIdRaw = btn.getAttribute('data-service-variant-id') || '';
        if (variantIdRaw.startsWith('REPLACE_') || !Number.parseInt(variantIdRaw, 10)) {
          const card = btn.closest('[data-service-option-card]');
          if (card) card.style.display = 'none';
          return;
        }
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          addService(btn);
        });
      });
    }

    wireCartUpsells();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    // Liquid placeholders are not interpolated inside {% javascript %} compiled assets.
    const sectionRoot = document.querySelector('.collection-page[data-section-id]');
    if (!sectionRoot) return;

    const bindFilterToggles = (scope) => {
      scope.querySelectorAll('.filter-toggle').forEach((toggle) => {
        if (toggle.dataset.bound === 'true') return;
        toggle.dataset.bound = 'true';

        toggle.addEventListener('click', () => {
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        });
      });
    };

    bindFilterToggles(sectionRoot);

    const sortSelect = sectionRoot.querySelector('#sort-select');
    if (sortSelect) {
      sortSelect.addEventListener('change', (event) => {
        const url = new URL(window.location.href);
        const value = event.target.value;

        if (value) {
          url.searchParams.set('sort_by', value);
        } else {
          url.searchParams.delete('sort_by');
        }

        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }

    const drawer = document.querySelector('[data-filter-drawer]');
    if (!drawer) return;

    const openButton = sectionRoot.querySelector('[data-open-filters]');
    const closeButtons = drawer.querySelectorAll('[data-drawer-close]');
    const drawerBody = drawer.querySelector('[data-drawer-body]');
    const desktopFilters = sectionRoot.querySelector('[data-collection-filters]');

    if (drawerBody && desktopFilters) {
      drawerBody.innerHTML = desktopFilters.innerHTML;
      bindFilterToggles(drawerBody);
    }

    const setDrawerState = (isOpen) => {
      drawer.classList.toggle('is-open', isOpen);
      drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    };

    if (openButton) {
      openButton.addEventListener('click', () => setDrawerState(true));
    }

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => setDrawerState(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        setDrawerState(false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-swatches-page]');
    if (!root) return;

    const maxSwatches = Number.parseInt(root.dataset.maxSwatches || '6', 10);
    const options = Array.from(root.querySelectorAll('[data-swatch-option]'));
    const hiddenField = root.querySelector('[id^="SelectedSwatches-"]');
    const countEl = root.querySelector('[data-swatch-count]');
    const summaryEl = root.querySelector('[data-swatch-summary]');
    const errorEl = root.querySelector('[data-swatch-error]');
    const limitWarningEl = root.querySelector('[data-swatch-limit-warning]');
    const formEl = root.querySelector('#SwatchRequestForm');

    function selectedOptions() {
      return options.filter((option) => option.checked);
    }

    function toggleLimitWarning(show) {
      if (!limitWarningEl) return;
      if (show) {
        limitWarningEl.textContent = `You can select up to ${maxSwatches} swatches only.`;
      }
      limitWarningEl.hidden = !show;
    }

    function refreshState() {
      const selected = selectedOptions();
      const selectedLabels = selected.map((option) => option.value);
      const selectedCount = selected.length;

      options.forEach((option) => {
        const optionCard = option.closest('.swatch-option');
        if (optionCard) {
          optionCard.classList.toggle('is-selected', option.checked);
        }
      });

      if (hiddenField) hiddenField.value = selectedLabels.join(', ');
      if (countEl) countEl.textContent = `${selectedCount} selected`;
      if (summaryEl) {
        summaryEl.textContent = selectedCount > 0
          ? selectedLabels.join(', ')
          : 'Nothing selected yet.';
      }
      if (selectedCount <= maxSwatches) {
        toggleLimitWarning(false);
      }
      if (errorEl) errorEl.hidden = true;
    }

    options.forEach((option) => {
      option.addEventListener('change', () => {
        const selectedCount = selectedOptions().length;
        if (option.checked && selectedCount > maxSwatches) {
          option.checked = false;
          toggleLimitWarning(true);
        } else {
          toggleLimitWarning(false);
        }
        refreshState();
      });
    });

    if (formEl) {
      formEl.addEventListener('submit', (event) => {
        if (selectedOptions().length < 1) {
          event.preventDefault();
          if (errorEl) errorEl.hidden = false;
        }
      });
    }

    refreshState();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Liquid placeholders are not interpolated inside {% javascript %} compiled assets.
    const sectionRoot = document.querySelector('.search-page[data-section-id]');
    if (!sectionRoot) return;

    const bindFilterToggles = (scope) => {
      scope.querySelectorAll('.filter-toggle').forEach((toggle) => {
        if (toggle.dataset.bound === 'true') return;
        toggle.dataset.bound = 'true';

        toggle.addEventListener('click', () => {
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        });
      });
    };

    bindFilterToggles(sectionRoot);

    const sortSelect = sectionRoot.querySelector('#search-sort');
    if (sortSelect) {
      sortSelect.addEventListener('change', (event) => {
        const url = new URL(window.location.href);
        const value = event.target.value;

        if (value === 'relevance') {
          url.searchParams.delete('sort_by');
        } else {
          url.searchParams.set('sort_by', value);
        }

        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }

    const drawer = document.getElementById('search-filter-drawer');
    if (!drawer) return;

    const openButton = sectionRoot.querySelector('[data-open-filters]');
    const closeButtons = drawer.querySelectorAll('[data-drawer-close]');
    const drawerBody = drawer.querySelector('[data-drawer-body]');
    const desktopFilters = sectionRoot.querySelector('#search-filters');

    if (drawerBody && desktopFilters) {
      drawerBody.innerHTML = desktopFilters.innerHTML;
      bindFilterToggles(drawerBody);
    }

    const setDrawerState = (isOpen) => {
      drawer.classList.toggle('is-open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    };

    if (openButton) {
      openButton.addEventListener('click', () => setDrawerState(true));
    }

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => setDrawerState(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        setDrawerState(false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
